{
  "version": "v4.2.5",
  "name": "TestDynamicArrayByteVec32",
  "bytecode": "00074028407340af40cc40fc411a4128010002030112d3545eacd4160116000005311342277b160113202c170216001602160213202a620201000204014028d3083a358916004313202e0c2f1342267b16014313202f1342287b1600000517020c170316031602314c0e1600160300001601414c0316033f0216030d2a17034a2e0b0201000203011fd3694941c216004313202e0c2f1342267b16014313202f1342287b160016010001170216020b244c031600024a05160016023d00040201000202010dd354ad273416004313202e0c2f1342267b160016014402010002030118d34b2e25b7160116000005311342277b160113202c170216000c1602621600160213202a16004362440201000101010ed30041471116004313202e0c2f1342267b16004313202d02010000000103d3676c3c33140002",
  "codeHash": "594861ab1850f3d1872ee687c87ddfeca8746bfe5b9ade07fabc4ca27c56661c",
  "fieldsSig": {
    "names": [],
    "types": [],
    "isMutable": []
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "get",
      "paramNames": [
        "array",
        "index"
      ],
      "paramTypes": [
        "ByteVec",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "find",
      "paramNames": [
        "array",
        "value"
      ],
      "paramTypes": [
        "ByteVec",
        "ByteVec"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "I256"
      ]
    },
    {
      "name": "remove",
      "paramNames": [
        "array",
        "value"
      ],
      "paramTypes": [
        "ByteVec",
        "ByteVec"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "push",
      "paramNames": [
        "array",
        "value"
      ],
      "paramTypes": [
        "ByteVec",
        "ByteVec"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "removeAt",
      "paramNames": [
        "array",
        "index"
      ],
      "paramTypes": [
        "ByteVec",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "size",
      "paramNames": [
        "array"
      ],
      "paramTypes": [
        "ByteVec"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "empty",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "ByteVec"
      ]
    }
  ],
  "constants": [
    {
      "name": "IntByteLength",
      "value": {
        "type": "U256",
        "value": "32"
      }
    }
  ],
  "enums": [
    {
      "name": "ErrorCode",
      "fields": [
        {
          "name": "InvalidArrayLength",
          "value": {
            "type": "U256",
            "value": "550"
          }
        },
        {
          "name": "IndexOutOfBound",
          "value": {
            "type": "U256",
            "value": "551"
          }
        },
        {
          "name": "InvalidByteVecLength",
          "value": {
            "type": "U256",
            "value": "552"
          }
        }
      ]
    }
  ]
}